import React, { useState } from "react";
import { Alert } from "antd";

import {
  localStorageGet,
  ORGANIZATION_PAUSE_BANNER_STORAGE_KEY,
} from "@/utils/storage";
import "./OrganizationPauseBanner.less";

const EXPIRES_AT = new Date("2026-09-07T23:59:59").getTime();
const MESSAGE =
  "Counterpart is taking an organizational pause August 24-28. If you intend on submitting a request for review of materials, please take this break into consideration when planning your timeline. If you need materials returned within the first two weeks of September, please submit review requests at least 3 weeks in advance, to account for the closure week, and keep in mind our office is also closed on Monday, September 7 for Labor Day.";

const getUserKey = () => {
  const info = localStorageGet("info");
  return info?.id || info?.userId || info?.email;
};

const getDismissedUsers = (): Record<string, boolean> => {
  const value = localStorage.getItem(ORGANIZATION_PAUSE_BANNER_STORAGE_KEY);
  if (!value) return {};

  try {
    return JSON.parse(value);
  } catch {
    return {};
  }
};

const isDismissedForCurrentUser = () => {
  const userKey = getUserKey();
  return !!userKey && !!getDismissedUsers()[String(userKey)];
};

const dismissForCurrentUser = () => {
  const userKey = getUserKey();
  if (!userKey) return;

  const dismissedUsers = {
    ...getDismissedUsers(),
    [String(userKey)]: true,
  };
  localStorage.setItem(
    ORGANIZATION_PAUSE_BANNER_STORAGE_KEY,
    JSON.stringify(dismissedUsers)
  );
};

const OrganizationPauseBanner = () => {
  const [visible, setVisible] = useState(() => {
    if (Date.now() > EXPIRES_AT) return false;
    return !isDismissedForCurrentUser();
  });

  const handleClose = () => {
    dismissForCurrentUser();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="organization-pause-banner">
      <Alert
        message={MESSAGE}
        type="warning"
        showIcon
        closable
        onClose={handleClose}
      />
    </div>
  );
};

export default OrganizationPauseBanner;
